module.exports = __webpack_public_path__ + "img/light_sensor.ffcf80da.svg";